import script from "./InputColorPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputColorPicker.vue?vue&type=script&lang=ts&setup=true"

import "./InputColorPicker.vue?vue&type=style&index=0&id=0a7cdf35&lang=css"
import "./InputColorPicker.vue?vue&type=style&index=1&id=0a7cdf35&lang=css"

const __exports__ = script;

export default __exports__